import { Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import RichTextEditorField from 'components/forms/richTextEditor/RichTextEditorField';
import { PropertyNotesCollapseStyled } from './PropertyNotes.styles';

const PropertyNotes = () => {
  const { t } = useTranslation();

  return (
    <PropertyNotesCollapseStyled
      label={t('pageProperty.mainSettings.propertyNotes.title')}
      variant="card"
      data-testid="property-notes"
    >
      <Row>
        <RichTextEditorField
          name="propertyNotes.notes"
          label={t('pageProperty.mainSettings.propertyNotes.propertyNotes')}
          colSmInput={9}
          colSmLabel={3}
        />
      </Row>
    </PropertyNotesCollapseStyled>
  );
};

export default PropertyNotes;
